import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/btn_close.svg'


const _withScopeId = n => (_pushScopeId("data-v-8c887b3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrpr" }
const _hoisted_2 = { class: "close" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "btn close"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "jr-flex jr-flex-col jr__filter jr-bg-gray-soft jr-fixed jr-top-4.5 jr-w-filter jr-h-screen jr-rounded",
    style: _normalizeStyle({width : _ctx.minimum ? '64px' : '300px'})
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.minimum)
        ? _renderSlot(_ctx.$slots, "default", { key: 0 }, undefined, true)
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "btn_close",
        style: _normalizeStyle({ transform: (_ctx.minimum ? 'rotate(0deg)' : 'rotate(180deg)') })
      }, [
        _createElementVNode("a", {
          href: "#",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickClose && _ctx.onClickClose(...args)))
        }, _hoisted_4)
      ], 4)
    ])
  ], 4))
}